import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import { currentUser } from '../../../../core/auth';
import { AppState } from '../../../../core/reducers';
import { QueryParamsModel, QueryResultsModel } from '../../../../core/_base/crud';
import { Dictionary } from '../models';

@Injectable({ providedIn: 'root' })
export class DictionaryService {
  private companyId;
  private baseUrl = environment.FORMS_CONCEPTS_BASE;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(currentUser).subscribe((user) => (this.companyId = user.companyID));
  }

  private static getDictionaryPageQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `company_id=${filter.companyId}&page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.id) fromString += `&id_has=${filter.id}`;
      if (filter.name) fromString += `&name_has=${filter.name}`;
    }

    return fromString;
  }

  getDictionaryPage(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const params = new HttpParams({
      fromString: DictionaryService.getDictionaryPageQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(`${this.baseUrl}/dictionaries`, { params });
  }

  findDictionaries(companyId: number | '', searchTerm: string): Observable<QueryResultsModel> {
    const queryParams = new QueryParamsModel({ companyId, searchTerm }, 'asc', 'name', 0, 25);

    return this.getDictionaryPage(queryParams);
  }

  findDictionariesAutocomplete(
    companyId: number | '',
    searchTerm: string,
  ): Observable<QueryResultsModel> {
    const queryParams = new QueryParamsModel({ companyId, searchTerm }, 'asc', 'name', 0, 25);
    const params = new HttpParams({
      fromString: DictionaryService.getDictionaryPageQueryString(queryParams),
    });

    return this.http.get<QueryResultsModel>(`${this.baseUrl}/dictionaries/autocomplete`, {
      params,
    });
  }

  createDictionary(dictionary: Dictionary): Observable<HttpResponse<{ data: Dictionary }>> {
    return this.http.post<{ data: Dictionary }>(`${this.baseUrl}/dictionaries`, dictionary, {
      observe: 'response',
    });
  }

  updateDictionary(dictionary: Dictionary): Observable<HttpResponse<{ data: Dictionary }>> {
    return this.http.put<{ data: Dictionary }>(
      `${this.baseUrl}/dictionaries/${dictionary.id}`,
      dictionary,
      { observe: 'response' },
    );
  }
}
